import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from 'react-i18next';

const OutsourcingSecurity2 = props => (
    <section id="outsourcing-security-section2" className="blue-bg my pt-5">
        <Container>
            <p className='mb-5'>
                <Trans i18nKey="services:outsourcingSecurity:section-1.txt"
                    components={{
                        br: <br />,
                        outsourcingPilar: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_pilar.path')} className="link" />
                    }}
                />
            </p>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingSecurity:section-2.title')}</h2>
            <p className='mb-5'>
                <Trans i18nKey="services:outsourcingSecurity:section-2.text"
                    components={{
                        br: <br />,
                        outsourcingVsFull: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_vs_full.path')} className="link" />
                    }}
                />
            </p>
            {[1, 2, 3].map(item => (
                <div key={item} className={item < 3 ? 'mb-5' : ''}>
                    <div className='d-flex align-items-center mb-4'>
                        <div className='arrow-container'>
                            <div className='arrow'>
                                <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            </div>
                        </div>
                        <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingSecurity:section-2.' + item + '.title')}</h3>
                    </div>
                    <p className={item < 3 ? '' : 'm-0'}>
                        <Trans i18nKey={'services:outsourcingSecurity:section-2.' + item + '.text'}
                            components={{
                                br: <br />,
                                outsourcingCost: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_cost.path')} className="link" />
                            }}
                        />
                    </p>
                </div>
            ))}
        </Container>
    </section>
);

export default OutsourcingSecurity2;
